import React from 'react';
import { useRouteMatch } from 'react-router';
import { FilterButton } from 'src/pages/consumer/components/DishFirstHeader';
import {
  useInlineFilterButtonsDockedStates,
  useIsContentShowing,
  useMoreFiltersReducer,
} from 'src/pages/consumer/components/DishFirstHeader/store';
import { useDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { getMoreFiltersCount } from '../../utils';

export const MoreFiltersButton: React.FC = () => {
  const match = useRouteMatch();
  const filters = useDishFirstExploreUrl({ match });
  const { isShowing: inlineFilterButtonsIsShowing } = useInlineFilterButtonsDockedStates();
  const { toggle, isShowing } = useMoreFiltersReducer();
  const isContentShowing = useIsContentShowing();

  const filtersCount = getMoreFiltersCount(filters);

  const hasSelection = filters.ecoFilter || filtersCount > 0;

  return (
    <FilterButton
      isActive={isShowing}
      onClick={toggle}
      order={4}
      quantity={filtersCount}
      show={inlineFilterButtonsIsShowing || isContentShowing}
      hasSelection={hasSelection}>
      More filters
    </FilterButton>
  );
};
